import type { SortDirection } from "../types/sorting";

export const allowedSortDirections: SortDirection[] = ["ascending", "descending"];

export const sortDirectionParam = "sort-direction";

export const sortedByParam = "sorted-by";
